import React from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import Malware from 'components/Organization/Features/Malware'

export default function MalwarePage(): React.ReactElement {
  return <Malware />
}

export const Head = getDocumentHead({
  title: 'Malware Identification and Blocking Platform',
  description:
    'Control D’s malware identification and blocking platform keeps your business secure, protected, and vigilant against emerging threats. Start a free trial today.',
})
